module.exports = __webpack_public_path__ + "img/bannerNews_2.45c9b1aa.png";